import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

let nextResultModalId = 0;

/**
 * Outcome of a membership action: header bar, green check, title and one line of detail
 * ("Plan paused successfully", "Plan activated successfully"). Presentational; the host decides
 * the text. Shared by the Customers → Subscriptions tab and the lane subscription popups.
 *
 * @selector app-subscription-result-modal
 * @input visible - Renders the modal.
 * @input header - Header bar text (plan name, or "Paused Subscription" on the lane).
 * @input title - Bold line under the check.
 * @input message - Detail line.
 * @output close - Close button, backdrop click or Escape.
 */
@Component({
  selector: 'app-subscription-result-modal',
  standalone: true,
  imports: [CommonModule, A11yModule],
  templateUrl: './subscription-result-modal.component.html',
  styleUrls: ['./subscription-result-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SubscriptionResultModalComponent {
  @Input() visible = false;
  @Input() header = '';
  @Input() title = '';
  @Input() message = '';

  @Output() close = new EventEmitter<void>();

  readonly titleId = `subscription-result-modal-title-${(nextResultModalId += 1)}`;

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.visible) {
      this.close.emit();
    }
  }
}
